import type { Dayjs } from "dayjs";
import type React from "react";
import type { ColumnMap } from "../../../../../model/deviceTimeSeries";
import type { AssetTimeSeriesRequestParams } from "../AssetDataSelectionForm.tsx";
import GenericCharts from "../GenericCharts";
// import HeatMeterFlowAndTemperatureChart from "./HeatMeterFlowAndTemperatureChart";

const ElectricityMeterCharts = (props: {
  mappedTimeSeriesColumns: ColumnMap;
  times: Dayjs[];
  params: AssetTimeSeriesRequestParams;
  loading: boolean;
  error?: Error;
}): React.ReactElement => {
  if (props.params.projection === "raw") {
    return <GenericCharts {...props} />;
  } else {
    return (
      <>
        <GenericCharts {...props} />
      </>
    );
  }
};

export default ElectricityMeterCharts;
